import { Wrench } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";

// Full-screen gate shown when maintenance_mode is ON. Admins bypass it so they
// can keep configuring the app.
export default function MaintenanceGate() {
  const { maintenance_mode } = useSettings();
  const { user } = useAuth();

  if (!maintenance_mode || user?.role === "admin") return null;

  return (
    <div
      data-testid="maintenance-gate"
      style={{
        position: "fixed", inset: 0, zIndex: 10000, background: "#000",
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", textAlign: "center", padding: 32, gap: 16,
      }}
    >
      <div style={{
        width: 72, height: 72, borderRadius: 999, background: "rgba(34,197,94,0.15)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Wrench size={34} color="#22c55e" />
      </div>
      <h1 className="font-sport uppercase" style={{ fontSize: 28, color: "#fff" }}>
        Maintenance en cours
      </h1>
      <p style={{ fontSize: 15, color: "#9ca3af", maxWidth: 320, lineHeight: 1.5 }}>
        MatchUp est momentanement indisponible pour une mise a jour. Reviens dans quelques minutes !
      </p>
    </div>
  );
}
